/**
 * Returns an answer array for all question 
 * types with no options
 *
 * @export
 * @param {*} answers
 * @param {*} question
 * @returns
 */
export default function(answers, question) {
    return [{
        key: '0',
        name: 'Answered',
        user: answers
    }]
}
